import React from "react";
import { useNavigate } from "react-router-dom";
import pageNotFound from "../Assets/page-not-found.png";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); 
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow flex flex-col justify-center items-center">
        <img
          src={pageNotFound}
          alt="404"
          className="max-w-[80%] md:max-w-[500px] h-auto mx-auto"
        />
        <div className="mt-[15px]">
          <button
            onClick={handleGoBack}
            className="bg-[#0072BB] text-[#FFFFFF] font-[600] py-[10px] px-[20px] rounded hover:bg-[#005a94] transition"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
